import * as React from 'react';
import { createComponent, EventName } from '@lit-labs/react';
import {
	YotpoTable as Table,
	YotpoTableCell as TableCell,
	YotpoTableHeader as TableHeader,
	YotpoTableHeaderCell as TableHeaderCell,
	YotpoTableRow as TableRow,
	YotpoTableActionsCell as TableActionsCell,
	YotpoSecondaryActionsMenu as SecondaryActionsMenu
} from '@yotpo-common/ui-components/components/table';
import { YotpoEvents } from '../enums';

export const YotpoTable = createComponent({
	react: React,
	tagName: 'yotpo-table',
	elementClass: Table,
	events: {
		onYotpoScrollEnd: YotpoEvents.scrollEnd as EventName<CustomEvent>
	}
});

export const YotpoTableCell = createComponent({
	react: React,
	tagName: 'yotpo-table-cell',
	elementClass: TableCell
});

export const YotpoTableHeader = createComponent({
	react: React,
	tagName: 'yotpo-table-header',
	elementClass: TableHeader
});

export const YotpoTableHeaderCell = createComponent({
	react: React,
	tagName: 'yotpo-table-header-cell',
	elementClass: TableHeaderCell
});

export const YotpoTableRow = createComponent({
	react: React,
	tagName: 'yotpo-table-row',
	elementClass: TableRow,
	events: {
		onYotpoMainAction: YotpoEvents.mainAction as EventName<CustomEvent>
	}
});

export const YotpoTableActionsCell = createComponent({
	react: React,
	tagName: 'yotpo-table-actions-cell',
	elementClass: TableActionsCell,
	events: {
		onYotpoMainAction: YotpoEvents.mainAction as EventName<CustomEvent>,
		onYotpoSelect: YotpoEvents.select as EventName<CustomEvent>
	}
});

export const YotpoSecondaryActionsMenu = createComponent({
	react: React,
	tagName: 'yotpo-secondary-actions-menu',
	elementClass: SecondaryActionsMenu,
	events: {
		onYotpoShow: YotpoEvents.show as EventName<CustomEvent>,
		onYotpoHide: YotpoEvents.hide as EventName<CustomEvent>,
		onYotpoSelect: YotpoEvents.select as EventName<CustomEvent>,
		onYotpoScrollEnd: YotpoEvents.scrollEnd as EventName<CustomEvent>
	}
});
